const root = '/assets/pdfs/';

const fileNames = {
  checkrFairCredit: 'summary-of-rights-under-fcra.pdf',
  checkrDisclosure: 'disclosure-regarding-background-investigation.pdf',
  checkrAgreement: 'acknowledgement-and-authorization-for-background-check.pdf',
};

export default (key) => `${root}${fileNames[key]}`;
